export function isCsvFile(file: File): boolean {
  return file.name.toLowerCase().endsWith('.csv');
}

export function downloadCsvTemplate(fileName: string, headers: readonly string[]): void {
  const csv = `${headers.join(',')}\r\n`;
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = fileName;
  link.click();

  URL.revokeObjectURL(url);
}
